module.exports = __webpack_public_path__ + "static/1-007-9e24bd9831cccd8d9081144381543ace.png";